import { Skeleton } from '@mui/material';
import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled, { css } from 'styled-components';

interface StyledProps {
  withoutLine: boolean;
  opacityIndex: number;
}

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 65rem;
  padding-bottom: 10rem;
  margin-bottom: 10rem;
  ${(props: StyledProps) =>
    !props.withoutLine &&
    css`
      border-bottom: 1rem solid ${COLORS.BORDER};
    `}
  ${(props: StyledProps) =>
    props.opacityIndex !== undefined &&
    css`
      opacity: ${1 - (props.opacityIndex * 0.2 + 0.2)};
    `}

  ${respondTo.smallTablet`
    flex-direction: column;
    align-items: flex-start;
    gap: 15rem;
    height: auto;
  `}
`;

export const LeftPart = styled.div`
  display: flex;
  align-items: center;
  gap: 15rem;

  ${respondTo.smallTablet`
    width: 100%;
    gap: 30rem;
  `}
`;

export const ModelNameLabel = styled.label`
  font-size: 18rem;
  font-weight: 400;
  color: ${COLORS.GREEN};

  ${respondTo.midTablet`
    font-size: 16rem;
  `}
`;

export const RightPart = styled.div`
  display: flex;
  align-items: center;
  gap: 15rem;

  ${respondTo.smallTablet`
    width: 100%;
    gap: 10rem;
    justify-content: space-between;
  `}

  ${respondTo.smallPhone`
    gap: 30rem;  
  `}
`;

export const Label = styled.label`
  font-size: 18rem;
  font-weight: 400;
  color: ${COLORS.BLACK};

  ${respondTo.smallLaptop`
    font-size: 16rem;
  `}

  ${respondTo.bigPhone`
    font-size: 14rem;
  `}
`;

export const IconWrapper = styled.div`
  margin-left: auto;
`;

export const OrderPerModelLabel = styled.label`
  font-size: 16rem;
  font-weight: 400;
  color: ${COLORS.GREEN};
`;

export const CircleSkeleton = styled(Skeleton)`
  border-radius: 15rem;
`;

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 15rem;

  ${respondTo.midTablet`
    flex-direction: column;
    gap: 0;
  `}

  ${respondTo.smallTablet`
    flex-direction: row;
    gap: 20rem;
    justify-content: space-between;
    width: 100%;
  `}
`;

export const ToggleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 15rem;
`;
